/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable operator-linebreak */
import React, { useEffect, useState } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import DashboardCard from 'ui/DashboardCard/DashboardCard';
import NavigationTitle, { LayoutType } from 'ui/NavigationTitle/NavigationTitle';
import Table from 'ui/Table/Table';
import api from 'api/api';
import Loader from 'ui/Loader/Loader';
import TablePagination from 'ui/TableInputs/TablePagination/TablePagination';
import NoData from 'ui/structure/NoData/NoData';
import { IApiResponse } from 'utils/models';
import NavigateBackBtn from 'ui/NavigateBackBtn/NavigateBackBtn';
import PaymentAdviceModal from 'components/modals/PaymentAdviceModal/PaymentAdviceModal';
import { ITransactionField } from 'ui/structure/TransactionCard';
import saveByteArray from 'utils/downloadAdvice';
import { getTransactionsArray } from 'utils/mapping/transactionCardMapper';
import allColumns from './columns';
import { IApiTransactionReport, ITransactionReport, MainTabsType, sortArrays } from './TransactionReport.model';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './TransactionReport.module.css';
import noDataImg from 'assets/img/no_data_pending.png';

type Props = {
  onClose: () => void;
  bulkDetail: any;
  activeTab: MainTabsType;
};

const BulkTransactionList = ({ onClose, bulkDetail, activeTab }: Props) => {
  const [submitting, setSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [bulkDataList, setBulkDataList] = useState<any>([]);
  const [selectedAdvice, setSelectedAdvice] = useState<ITransactionField[]>([]);
  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const [isPaymentAdviceOpen, setIsPaymnetAdviceOpen] = useState<boolean>(false);
  const [confirmationData, setConfirmationData] = useState<ITransactionReport>();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement | any>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const downMdScreen = useMediaQuery(useTheme().breakpoints.down('sm'));
  const emptyMessage = 'No Transaction Found';

  const closePaymentAdvice = () => {
    setIsPaymnetAdviceOpen(false);
  };

  const handleCellClick = (cell: { row: { original: ITransactionReport }; column: { Header: string } }) => {
    if (cell?.column.Header === 'Advice') {
      setIsPaymnetAdviceOpen(true);
      setConfirmationData(cell.row.original);

      const { sourceAccount,
        sourceAccountName,
        amount,
        beneficiaryAccount,
        beneficiaryName,
        narration,
        id,
        transactionDate,
        beneficiaryBank,
        scheduleId,
      } = cell.row.original;

      const readyValues = {
        sourceAccount: Number(sourceAccount),
        sourceAccountName,
        amount,
        beneficiaryAccount,
        beneficiaryName,
        narration,
        id,
        scheduleId,
        transactionDate,
        beneficiaryBank,
        transactionType: cell.row.original.transactionType,
      };
      setSelectedAdvice(getTransactionsArray(readyValues, undefined, undefined, sortArrays));
    }
  };

  useEffect(() => {
    const requestBody = {
      ...bulkDetail,
      scheduleId: bulkDetail.bulkId,
      bulkId: bulkDetail.bulkId,
      pageNumber,
      pageSize,
    };
    setSubmitting(true);

    // console.log(requestBody);

    api
      .post('/transaction-reports/fetchBulkDrill', requestBody)
      .then((data: IApiTransactionReport) => {
        // console.log('drill down', data);
        setSubmitting(false);
        setTotalRows(data.count);
        setBulkDataList(data?.transfers);
      })
      .catch((error: IApiResponse) => {
        console.error('failed', error.description);
        setSubmitting(false);
      });
  }, [bulkDetail, pageNumber, pageSize]);

  const handleDownloadAdvice = (type: string) => {
    setIsLoading(true);

    const requestBody = {
      transactionId: confirmationData?.id,
      reportType: type?.toLocaleUpperCase(),
    };

    api
      .post('/transaction-reports/download-payment-advice', requestBody, true, false, 'arraybuffer')
      .then((data: string) => {
        saveByteArray(data, type, 'Payment_Advice');
        setIsLoading(false);
      })
      .catch((error: IApiResponse) => {
        console.error(error.description);
        setIsLoading(false);
      });
  };

  const getSelectedColumn = () => {
    const { bulkTransferListColumns, mobileMoney, prepaidCard } = allColumns;
    // console.log(activeTab);

    switch (activeTab) {
      case 1:
        return mobileMoney.filter(
          (item) =>
            item?.accessor !== 'totalCount' &&
            item?.accessor !== 'bulkId' &&
            item?.accessor !== 'totalAmount' &&
            item?.accessor !== 'scheduleId' &&
            item?.accessor !== 'charge',
        );
      case 2:
        return prepaidCard.filter(
          (item) =>
            item?.accessor !== 'scheduleId' &&
            item?.accessor !== 'sourceAccount' &&
            item?.accessor !== 'created' &&
            item?.accessor !== 'finalApproval' &&
            item?.accessor !== 'sourceAccount',
        );
      default:
        return bulkTransferListColumns;
    }
  };

  const handlePageChange = (_: React.ChangeEvent<unknown>, newPage: number) => {
    setPageNumber(newPage);
  };

  const handlePageSizeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newPageSize = parseInt(event.target.value as string, 10);
    setPageSize(newPageSize);
    setPageNumber(1);
  };

  const handleDownloadReport = (type: string) => {
    setIsDownloading(true);

    const requestBody = {
      // ...searchParams,
      // transactionType,
      downloadType: type?.toLocaleUpperCase(),
    };
    api
      .post('/transaction-reports/download', requestBody, true, false, 'arraybuffer')
      .then((data: string) => {
        saveByteArray(data, type, 'PDF_Report');
        setIsDownloading(false);
      })
      .catch((error: IApiResponse) => {
        console.error(error.description);
        setIsDownloading(false);
      });
  };

  const handleClose = (type: string) => {
    setAnchorEl(null);
    if (typeof type === 'string') {
      handleDownloadReport(type);
    }
  };

  if (submitting) {
    return (
      <div className={styles.m25}>
        <Loader />
      </div>
    );
  }

  if (bulkDataList && bulkDataList.length === 0) {
    return (
      <>
        {!downMdScreen && (
          <NavigateBackBtn onBackBtnClick={onClose}>
            Back
          </NavigateBackBtn>
        )}
        <div className={styles.nodata} />
        <NoData
          img={noDataImg}
          title="No transactions found"
          subtitle="No results for your filters were found. Kindly try other filers."
        />
      </>
    );
  }

  return (
    <>
      <DashboardCard>
        {!downMdScreen && (
          <NavigateBackBtn onBackBtnClick={onClose}>
            Back
          </NavigateBackBtn>
        )}
        <NavigationTitle
          to="#/"
          layoutType={LayoutType.dashboard}
          // onClick={mobileFillingInfo ? openCategorySelector : onClose}
        >
          Bulk Transfers List
        </NavigationTitle>
        <div>
          <Table
            columns={getSelectedColumn()}
            data={bulkDataList}
            getCellValue={handleCellClick}
            emptyTableMessage={emptyMessage}
          />
          <TablePagination
            count={Math.ceil(totalRows / pageSize)}
            page={pageNumber}
            pageSize={pageSize}
            totalCount={totalRows}
            handlePageChange={handlePageChange}
            handlePageSizeChange={handlePageSizeChange}
          />
        </div>
      </DashboardCard>
      <PaymentAdviceModal
        open={isPaymentAdviceOpen}
        onClose={closePaymentAdvice}
        data={selectedAdvice}
        onSubmit={handleDownloadAdvice}
        submitting={isLoading}
      />
    </>
  );
};

export default BulkTransactionList;
